<template>
  <div class="page">
    <!-- 条件查找 -->
    <van-dropdown-menu>
      <van-dropdown-item
        :title="templateTitle"
        v-model="value1"
        @change="templateType(value1)"
        :options="typeTemplate"
      />
      <van-dropdown-item
        :title="classTitle"
        @change="handleChange"
        v-model="value2"
        :options="classTemplate"
      />

      <!-- 颜色选择 -->
      <van-dropdown-item :title="colorTitle" ref="item">
        <div class="color-list">
          <div
            @click="clickEvent(item.id)"
            v-for="item in colorList"
            :key="item.id"
            :class="{
              'color-list-item': isFirstClass,
              current: item.id == active_colorId ? 'isCurrent' : ''
            }"
          >
            <div class="color-item">
              <div class="no-impos" v-show="item.id == -1">不限</div>

              <div
                class="colorBox"
                :style="{
                  backgroundColor: item.color.main,
                }"
              ></div>
              <div
                class="colorBox"
                :style="{
                  backgroundColor: item.color.aux,
                }"
              ></div>
            </div>
          </div>
        </div>
        <!-- </van-radio> -->
        <!-- <van-button block type="info" @click="onConfirm">确认</van-button> -->
        <!-- <van-button block type="info" @click="onConfirm">确认</van-button> -->
      </van-dropdown-item>
      <!-- <van-dropdown-item v-model="value3" :options="colorTemplate" v-if="isHidden"/> -->
    </van-dropdown-menu>
    <!-- 模板选择 -->
    <div class="context">
      <div class="card contextItem" v-for="item in imageList" :key="item.id">
        <img :src="item.cover" class="image" />
        <div style="padding: 14px;" class="btnTitle">
          <span>{{ item.name }}</span>
          <van-button
            type="info"
            round
            class="button"
            @click="createStore(item.id)"
            >立即使用</van-button
          >
        </div>
      </div>
      <div class="card blank-card" v-if="imageList.length == 0">
        <div class="image-cover-blank">
          <img src="../assets/images/nocover.png" alt />
          <div class="blank-card-title">创建一套空白模板</div>
          <van-button
            type="info"
            size="small"
            class="default-background"
            shape="circle"
            @click="createStore(-1)"
            >立即创建</van-button
          >
        </div>
      </div>
    </div>

    <!-- 动画弹框 -->

    <van-dialog
      v-model="animationCreate"
      :show-cancel-button="false"
      :showConfirmButton="false"
      width="300px"
    >
      <div class="loader21 loader">
        <div class="loader-21  loader-box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <p class="generated-store">正在努力为您生成店铺中...</p>
    </van-dialog>
    <!-- </Modal> -->
    <!-- 动画成功 弹框-->
    <van-dialog
      v-model="animationSucceed"
      :show-cancel-button="false"
      :showConfirmButton="false"
      width="300px"
      class="success-dialog"
    >
      <div class="right-into">
        <!-- <i class="iconfont passed"></i> -->
        <van-icon name="passed" class="iconfont" />
      </div>
      <p class="generated-store">店铺创建成功，自动进入店铺...</p>
      <!-- </Modal> -->
    </van-dialog>
  </div>
</template>
<script>
import { getStoreInitialResults } from '@/api/store'
import { getStore } from '@/api/buy/shop'
import { Dialog, Toast } from 'vant'
import { type } from '../libs/util'
export default {
  data() {
    return {
      value1: -1,
      value2: -1,
      radio: '1',
      heightDefault: 16,
      typeTemplate: [
        { text: '不限', value: 0 },
        { text: '线上电商', value: 1 },
        { text: '同城服务', value: 2 }
      ], // 模板类型
      classTemplate: [], // 模板分类
      // colorTemplate: [
      //   { text: '测试1', value: 0 }
      // ], // 模板颜色
      pageIndex: 1, // 当前页码
      pageSize: 2,
      total: 0,
      active_colorId: -1, //选中颜色的id
      active_categoryId: -1, //选中分类id
      imageList: [], // 图片展示列表
      // 参数模板
      create_params: {},
      goodsCategorys: [], // 全部分类
      childrenCategorys: [], // 二级分类
      colorList: [
        //颜色列表
        {
          id: -1,
          color: {
            backgorund: '#ffffff' //背景色
          }
        },
        {
          id: 1,
          color: {
            main: '#ff4444', //主色
            aux: '#ff8855', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#ff5a5a',
              end: '#fe7d7d'
            } //渐变色
          }
        },
        {
          id: 2,
          color: {
            main: '#65c4aa', //主色
            aux: '#8edbc6', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#c3ede2',
              end: '#69c7ad'
            } //渐变色
          }
        },
        {
          id: 3,
          color: {
            main: '#c3a769', //主色
            aux: '#D8BF88', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#e0c68d',
              end: '#ba9c5b'
            } //渐变色
          }
        },
        {
          id: 4,
          color: {
            main: '#ff5e15', //主色
            aux: '#ff9300', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#fead74',
              end: '#fe8874'
            } //渐变色
          }
        },
        {
          id: 5,
          color: {
            main: '#69bc6f', //主色
            aux: '#b3dfb7', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#b3dfb7',
              end: '#71c077'
            } //渐变色
          }
        },
        {
          id: 6,
          color: {
            main: '#1d262e', //主色
            aux: '#ffd100', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#333333',
              end: '#5c5c5c'
            } //渐变色
          }
        },
        {
          id: 7,
          color: {
            main: '#ff557c', //主色
            aux: '#ff8fa9', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#fdc5bd',
              end: '#f89aa7'
            } //渐变色
          }
        },
        {
          id: 8,
          color: {
            main: '#7ac5ff', //主色
            aux: '#b3deff', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#bbe2ff',
              end: '#7ac5ff'
            } //渐变色
          }
        },
        {
          id: 9,
          color: {
            main: '#7A3232', //主色
            aux: '#916752', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#a25d57',
              end: '#7a3232'
            } //渐变色
          }
        },
        {
          id: 10,
          color: {
            main: '#EDAD61', //主色
            aux: '#F8CB75', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#f7c873',
              end: '#edad61'
            } //渐变色
          }
        },
        {
          id: 11,
          color: {
            main: '#5977C1', //主色
            aux: '#7E9DE8', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#7a99e4',
              end: '#5977c1'
            } //渐变色
          }
        },
        {
          id: 12,
          color: {
            main: '#478D28', //主色
            aux: '#79BC5B', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#6eb269',
              end: '#4e8138'
            } //渐变色
          }
        },
        {
          id: 13,
          color: {
            main: '#75D9DF', //主色
            aux: '#75B1DF', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#75d5df',
              end: '#75b1df'
            } //渐变色
          }
        },
        {
          id: 14,
          color: {
            main: '#875E39', //主色
            aux: '#D7A374', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#d19e70',
              end: '#9e7149'
            } //渐变色
          }
        },
        {
          id: 15,
          color: {
            main: '#D37EF3', //主色
            aux: '#F5ADF2', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#f1b3fe',
              end: '#d37ef3'
            } //渐变色
          }
        },
        {
          id: 16,
          color: {
            main: '#C13838', //主色
            aux: '#F7B676', //辅色
            backgorund: '#ffffff', //背景色
            gradient: {
              start: '#ce5f4f',
              end: '#c13838'
            } //渐变色
          }
        }
      ], // 模板颜色配色
      animationCreate: false, //动画弹框
      animationSucceed: false, //动画弹框成功
      isFirstClass: true, // 颜色模板样式
      isCurrent: true, // 当前选中的色块模板
      colorTitle: '模板配色',
      templateTitle: '模板类型',
      classTitle: '模板分类'
    }
  },
  created() {
    // console.log(this.$route.params)
    this.create_params = JSON.parse(localStorage.getItem('params'))
    this.goodsCategorys = JSON.parse(sessionStorage.getItem('categoryList'))
    // 获取用户选择的模板id
    this.active_categoryId = this.create_params.business_id
    this.getColumnsList()
    this.getTemplateList()
  },
  methods: {
    templateType(value) {
      // 根据value进行刷新
      if (value == 0) {
        this.active_categoryId = -1
        this.getTemplateList()
      }
      // console.log(value)
      // 更具type值进行 筛选二级分类
      let type = value == 0 ? -1 : value == 1 ? 1 : 2
      this.classTemplate = []
      if (type == -1) {
        this.goodsCategorys.forEach((item1, index1) => {
          this.classTemplate.push({
            text: item1.label,
            value: item1.value
          })
        })
        this.templateTitle = '不限'
        this.classTitle = '模块分类'
        this.value2 = -1
        // this.classTemplate = [...this.goodsCategorys];
      } else {
        this.goodsCategorys.forEach(item => {
          console.log(item)
          let typeItem = item.marketing_channel.filter(
            c => c.goods_category_channel == type
          )
          if (typeItem.length > 0) {
            this.classTemplate.push({
              text: item.label,
              value: item.value
            })
          }
        })
        if (type == 1) {
          this.templateTitle = '线上电商'
          this.classTitle = this.classTemplate[0].text
          this.value2 = this.classTemplate[0].value
          this.active_categoryId = this.classTemplate[0].value
          this.getTemplateList()
        } else {
          this.templateTitle = '同城服务'
          this.classTitle = this.classTemplate[0].text
          this.value2 = this.classTemplate[0].value
          this.active_categoryId = this.classTemplate[0].value
          this.getTemplateList()
        }
        // this.selectModel(this.goodsCategorys[0], 0,this.goodsCategorys[0].children.length==0);
      }
    },
    // 模板分类选项
    handleChange(value) {
      console.log(value)
      // console.log(this.classTemplate)
      let a = this.classTemplate.filter(item => {
        return value == item.value
      })
      this.classTitle = a[0].text
      this.active_categoryId = value == 0 ? '-1' : value
      this.getTemplateList()
    },
    // 颜色模板选中状态
    clickEvent(id) {
      console.log(id)
      if (id == -1) {
        this.colorTitle = '不限'
      } else {
        this.colorTitle = '模板配色'
      }
      this.active_colorId = id

      if (this.active_colorId == id) {
        this.isCurrent = true
      }
      {
        this.isCurrent = false
      }

      this.pageIndex = 1
      // 关闭颜色选择框
      this.$refs.item.toggle()
      this.getTemplateList()
    },
    // 分类列表
    getColumnsList() {
      console.log(this.goodsCategorys)
      if (this.goodsCategorys == null) {
        return []
      }
      this.goodsCategorys.forEach((item1, index1) => {
        this.classTemplate.push({
          text: item1.label,
          value: item1.value
        })
      })
      this.goodsCategorys.map((item, index) => {
        if (item.value == this.create_params.business_id) {
          let a = this.classTemplate.filter(item => {
            return this.create_params.business_id == item.value
          })
          this.classTitle = a[0].text
          return (this.value2 = this.create_params.business_id)
        }
      })
      console.log(this.value2)
    },
    getTemplateList() {
      console.log(this.active_colorId, this.active_categoryId)

      // 获取模板列表
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      this.$api
        .getTemplateList({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          color: this.active_colorId,
          category_id: this.active_categoryId
        })
        .then(res => {
          if (res.code !== 200) {
            return Toast.fail('获取模板列表失败')
          }
          Toast.clear()
          console.log(res.response, '获取模板列表获取模板列表')
          this.imageList = res.response.data
          this.total = res.response.total
        })
    },
    // 创建店铺
    createStore(template_id) {
      // return this.animationSucceed = true
      this.animationCreate = true
      this.create_params.template_id = template_id
      this.$api.createStore(this.create_params).then(res => {
        if (res.code == 200 && res.response.success) {
          this.getInitialResults(res.response.id)
        } else {
          // this.$message.error(res.msg);
          // Dialog.confirm({
          //   title: '提示',
          //   message: res.msg
          // })
          Toast(res.msg)
          this.animationCreate = false
        }
      })
    },
    //获取店铺初始化状态
    getInitialResults(storeId) {
      getStoreInitialResults({ store_id: storeId }).then(res => {
        if (res.code == 200) {
          if (res.response.state) {
            this.animationCreate = false
            this.animationSucceed = true
            setTimeout(this.goPanel(storeId), 5000)
          } else {
            setTimeout(() => {
              this.getInitialResults(storeId)
            }, 5000)
          }
        } else {
          // this.animationCreate = false
          // this.$Message.error(res.msg)
          Dialog.confirm({
            title: '提示',
            message: res.msg
          })
        }
      })
    },
    goPanel(id) {
      // console.log(id);
      let _this = this
      // if (this.$store.state.shopInfo[id] == undefined) {
      this.$api
        .getShopSign({
          storeid: id
        })
        .then(res => {
          // console.log(res);
          if (res.code == '200') {
            _this.$store.commit('changeManageState', id)
            // _this.$ba.trackEvent('进入店铺', 'click', `店铺id：${id}`)
            let data = {}
            data.store_id = id
            data.token = res.response
            _this.$store.commit('addShopInfo', data)
            // console.log(data);
            _this.$api.getStoreInfo().then(function(res) {
              // console.log(res);
              if (res.code == '200') {
                let shop = res.response
                shop.token = data.token
                _this.$store.commit('addShopInfo', shop)
                getStore({
                  short_url: shop.shorturl
                }).then(res1 => {
                  if (res1.code == 200) {
                    _this.$store.commit('setShopIntercept', res1.response.token)
                    _this.$router.push({
                      name: 'success',
                      params: {
                        shop: id
                      }
                    })
                  } else {
                    Notify({ type: 'danger', message: '获取店铺信息失败' })
                  }
                })
              }
            })
          } else {
            // _this.$ba.trackEvent(
            //   '进入店铺',
            //   'click',
            //   `进入店铺失败：${res.msg}`
            // )
          }
        })
    }
  }
}
</script>

<style lang="css" scoped>
.page {
  /* height: 100%; */
  background-color: #f8f8f8 !important;
}
.van-dropdown-menu {
  margin-bottom: 16px;
}
img {
  width: 100%;
  height: 244px;
}
.context {
  /* height: 100%; */
  padding: 0 16px 10px 16px;
}
.image {
  width: 100%;
  vertical-align: middle;
}
.btnTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
}
.contextItem {
  margin-bottom: 22px;
}
.van-dropdown-item {
  margin: 3px 0 !important;
}

/* 动画展示效果 */

.generated-store {
  margin: 0;
  text-align: center;
  color: #999;
  letter-spacing: 1px;
  padding: 10px 0;
}

.right-into {
  text-align: center;
}
.right-into .iconfont {
  font-size: 50px;
  color: #3d6eff;
}

.loader {
  height: 75px;
  justify-content: center;
  display: flex;
  align-items: center;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ivu-modal {
  top: 0;
}
@keyframes loader21 {
  0% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 0.3);
  }
}
.loader-box {
  margin-top: 10px;
}
.loader-box div {
  margin: 0 3px;
}
.loader-21 div {
  width: 5px;
  height: 35px;
  background: #3d6eff;
  border-radius: 2px;
  display: inline-block;
}
.loader-21 div:nth-child(1) {
  animation: loader21 0.5s -0.3s ease-in-out infinite alternate;
}
.loader-21 div:nth-child(2) {
  animation: loader21 0.5s -0.15s ease-in-out infinite alternate;
}
.loader-21 div:nth-child(3) {
  animation: loader21 0.5s 0s ease-in-out infinite alternate;
}
.loader-21 div:nth-child(4) {
  animation: loader21 0.5s -0.15s ease-in-out infinite alternate;
}
.loader-21 div:nth-child(5) {
  animation: loader21 0.5s -0.4s ease-in-out infinite alternate;
}

.image-cover-blank {
  /* display: flex; */
  width: 245px;
  height: 245px;
  text-align: center;
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); */
  /* flex-direction: column; */
  /* align-items: center; */
  margin: 0;
}
.image-cover-blank > img {
  display: block;
  width: 100%;
}
.blank-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
  padding-top: 20px;
  margin-bottom: 10px;
}
.blank-card-title {
  margin: 10px 0;
  font-size: 16px;
}
.btnTitle > .van-button {
  /* margin-bottom: 10px !important; */
  height: 28.5px;
  /* width: 87px; */
  font-size: 14px;
  line-height: 28.5px;
}
.card {
  width: 100%;
  height: 304px;
  background-color: #ffffff;
  box-shadow: 0px 4px 6px 2px rgba(96, 105, 114, 0.08);
  border-radius: 6px;
  overflow: hidden;
}
/* 颜色处理 */
.color-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.color-list-item {
  height: 20px;
  width: 40px;
  border-radius: 10px;
  overflow: hidden;
  margin: 10px 18px;
  height: 16px;
}
.color-item {
  height: 16px;
  width: 40px;
  overflow: hidden;
  border-radius: 10px;
}
.colorBox {
  width: 20px;
  height: 16px;
  float: left;
}
.success-dialog {
  padding: 20px 10px;
}
.van-button--info {
  color: #fff;
  background-color: #3d6eff;
  border: 0.02667rem solid #3d6eff;
}
.no-impos {
  width: 40px;
  height: 16px;
  line-height: 16px;
  /* border-radius: 5px; */
  /* overflow: hidden; */
  font-size: 14px;
  text-align: center;
}
.current {
  border: 2px solid #3d6eff;
  border-radius: 12px;
  /* box-sizing: border-box; */
  padding: 2px;
  margin: 6px 14px;
  color: #3d6eff;
}
</style>
